'use client'

import React, { Fragment } from 'react'
import HeaderLink from './headerLink'
import { StyledTopLinks } from './topLinks.styles'
import { Box, Divider, useTheme } from '@mui/material'
import { useGlobalState } from '@biolumina/ui/context/globalStateProvider'
import { GhostLink } from '@biolumina/ui/components/link/ghostLink'

// Links beyond index 2 are CSS-hidden on mobile to avoid hydration-driven layout shift
const MOBILE_VISIBLE_COUNT = 3

export default function TopLinks() {
  const { siteData: { topLinks: links }} = useGlobalState()
  const theme = useTheme()

  return (
    <StyledTopLinks className="topLinks" direction="row">
      {links.map(({ display, ghost = true, ...navItem }, index) => {
        // Wrap extra links in a Box hidden on mobile; divider after last mobile-visible link also hidden
        const linkHiddenOnMobile = index >= MOBILE_VISIBLE_COUNT
        const dividerHiddenOnMobile = index >= MOBILE_VISIBLE_COUNT - 1

        const linkEl = ghost ? (
          <GhostLink
            component={HeaderLink}
            data-tracking="top-utility-nav-item"
            display={display}
            {...navItem}
          />
        ) : (
          <HeaderLink
            data-tracking="top-utility-nav-item"
            display={display}
            {...navItem}
          />
        )

        return (
          <Fragment key={navItem.href}>
            {linkHiddenOnMobile ? (
              <Box sx={{ display: { xs: 'none', md: 'contents' } }}>{linkEl}</Box>
            ) : linkEl}
            {index < links.length - 1 && (
              <Divider
                key={`divider-${navItem.href}`}
                orientation="vertical"
                sx={{
                  bgcolor: theme.palette.grey[600],
                  ...(dividerHiddenOnMobile ? { display: { xs: 'none', md: 'block' } } : {}),
                }}
                flexItem
              />
            )}
          </Fragment>
        )
      })}
    </StyledTopLinks>
  )
}
